import { render, staticRenderFns } from "./AddressListItem.vue?vue&type=template&id=0b4b5dfe&scoped=true&"
import script from "./AddressListItem.vue?vue&type=script&lang=js&"
export * from "./AddressListItem.vue?vue&type=script&lang=js&"
import style0 from "./AddressListItem.vue?vue&type=style&index=0&id=0b4b5dfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4b5dfe",
  null
  
)

export default component.exports